<template lang="pug">

.l-map-kumo-svg(v-if="item.type==1")
  svg(version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :width="item.width + 'px'" :height="item.height + 'px'" viewBox="0 0 634 184" enable-background="new 0 0 634 184" xml:space="preserve")
    path(:fill="item.color" d="M586.2,91.4h-192c18.7-5.6,32.3-22.9,32.3-43.4v0c0-25-20.3-45.3-45.3-45.3h-334C22.1,2.6,1.8,22.9,1.8,48v0 c0,25,20.3,45.3,45.3,45.3h157.3c-18.7,5.6-32.3,22.9-32.3,43.4v0c0,25,20.3,45.3,45.3,45.3h368.7c25,0,45.3-20.3,45.3-45.3v0 C631.5,111.7,611.2,91.4,586.2,91.4z")
.l-map-kumo-svg(v-if="item.type==2")
  svg(version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :width="item.width+ 'px'" :height="item.height + 'px'" viewBox="0 0 590 184" enable-background="new 0 0 590 184" xml:space="preserve")
    path(:fill="item.color" d="M543.1,2h-370c-24.7,0-45,20.2-45,45v0c0,24.6,20,44.7,44.5,45h-126c-24.7,0-45,20.2-45,45v0 c0,24.7,20.2,45,45,45h322.3c24.7,0,45-20.2,45-45v0c0-24.6-20-44.7-44.5-45h173.7c24.7,0,45-20.2,45-45v0 C588.1,22.2,567.8,2,543.1,2z")
.l-map-kumo-svg(v-if="item.type==3")
  svg(version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" :width="item.width + 'px'" :height="item.height + 'px'" viewBox="0 0 498 184" enable-background="new 0 0 498 184" xml:space="preserve")
    path(:fill="item.color" d="M451.8,2.4H172.5c-24.7,0-45,20.2-45,45v0c0,24.6,20,44.7,44.5,45H46c-24.7,0-45,20.2-45,45v0 c0,24.7,20.2,45,45,45h322.3c24.7,0,45-20.2,45-45v0c0-24.6-20-44.7-44.5-45h83c24.7,0,45-20.2,45-45v0 C496.8,22.6,476.6,2.4,451.8,2.4z")


</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'
</style>


<script>
import { defineComponent} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name:'MapKumoSvg',

  props:{
    item:{
      type:Object,
      default: function() {
        return {}
      }
    }
  },

  setup(props, context) {
    return{
    }
  }
})
</script>
